import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Plus, Search, Edit2, Trash2, Truck, Clipboard, CheckCircle, X } from 'react-feather';
import { base_api_url } from '../../../environment.jsx';
import './Fournisseurs.css';

const CATEGORIES = ['ALIMENTAIRE', 'BOISSONS', 'EQUIPEMENT', 'DIVERS'];

const CATEGORIE_COLORS = {
    ALIMENTAIRE: 'cat-alimentaire',
    BOISSONS: 'cat-boissons',
    EQUIPEMENT: 'cat-equipements',
    DIVERS: 'cat-autre',
};


const ModalAjout = ({ onClose, onSave, loading }) => {
    const [form, setForm] = useState({
        nom_fournisseur: '',
        categorie: CATEGORIES[0],
        nom_contact: '',
        telephone: '',
        siren: '',
    });

    const handle = (e) =>
        setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

    const handleSubmit = () => {
        if (!form.nom_fournisseur.trim()) {
            Swal.fire({ icon: 'warning', text: 'Le nom de l\'entreprise est requis.', toast: true, position: 'bottom-end', showConfirmButton: false, timer: 3000, customClass: { popup: 'pixel-toast' } });
            return;
        }
        onSave(form);
    };

    return (
        <>
            <div className="f-backdrop" onClick={onClose} />
            <div className="f-modal">
                {/* Header */}
                <div className="f-modal-header">
                    <h5>Ajouter un fournisseur</h5>
                    <button className="f-modal-close" onClick={onClose} type="button">
                        <X size={18} />
                    </button>
                </div>

                {/* Body */}
                <div className="f-modal-body">
                    {/* NOM DE L'ENTREPRISE */}
                    <div className="f-field">
                        <label className="f-field-label">
                            NOM DE L&apos;ENTREPRISE <span className="f-required">*</span>
                        </label>
                        <input
                            name="nom_fournisseur"
                            value={form.nom_fournisseur}
                            onChange={handle}
                            className="f-input"
                            placeholder=""
                        />
                    </div>

                    {/* CATÉGORIE */}
                    <div className="f-field">
                        <label className="f-field-label">
                            CATÉGORIE <span className="f-required">*</span>
                        </label>
                        <select
                            name="categorie"
                            value={form.categorie}
                            onChange={handle}
                            className="f-select"
                        >
                            {CATEGORIES.map((c) => (
                                <option key={c} value={c}>{c}</option>
                            ))}
                        </select>
                    </div>

                    {/* NOM DU CONTACT */}
                    <div className="f-field">
                        <label className="f-field-label">NOM DU CONTACT</label>
                        <input
                            name="nom_contact"
                            value={form.nom_contact}
                            onChange={handle}
                            className="f-input"
                            placeholder="Nom du commercial"
                        />
                    </div>

                    {/* TÉLÉPHONE */}
                    <div className="f-field">
                        <label className="f-field-label">TÉLÉPHONE</label>
                        <input
                            name="telephone"
                            value={form.telephone}
                            onChange={handle}
                            className="f-input"
                            type="text"
                            placeholder=""
                        />
                    </div>

                    {/* SIREN */}
                    <div className="f-field">
                        <label className="f-field-label">SIREN</label>
                        <input
                            name="siren"
                            value={form.siren}
                            onChange={handle}
                            className="f-input"
                            placeholder="Ex : BP-1234"
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className="f-modal-footer">
                    <button
                        className="f-btn-primary"
                        onClick={handleSubmit}
                        disabled={loading}
                        type="button"
                    >
                        {loading ? 'Ajout en cours…' : 'Ajouter'}
                    </button>
                    <button className="f-btn-secondary" onClick={onClose} type="button">
                        Annuler
                    </button>
                </div>
            </div>
        </>
    );
};

ModalAjout.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};


const ModalEdit = ({ onClose, onSave, initial, loading }) => {
    const [form, setForm] = useState({
        nom_fournisseur: initial?.nom_fournisseur || '',
        categorie: initial?.categorie || CATEGORIES[0],
        nom_contact: initial?.nom_contact || '',
        telephone: initial?.telephone?.toString() || '',
        siren: initial?.siren || '',
        statut: initial?.statut ?? 1,
    });

    const handle = (e) =>
        setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

    const handleSubmit = () => {
        if (!form.nom_fournisseur.trim()) {
            Swal.fire({ icon: 'warning', text: "Le nom de l'entreprise est requis.", toast: true, position: 'bottom-end', showConfirmButton: false, timer: 3000, customClass: { popup: 'pixel-toast' } });
            return;
        }
        onSave({ ...form, statut: Number(form.statut) });
    };

    return (
        <>
            <div className="f-backdrop" onClick={onClose} />
            <div className="f-modal">
                <div className="f-modal-header">
                    <h5>Modifier le fournisseur</h5>
                    <button className="f-modal-close" onClick={onClose} type="button"><X size={18} /></button>
                </div>
                <div className="f-modal-body">
                    <div className="f-field">
                        <label className="f-field-label">NOM DE L&apos;ENTREPRISE <span className="f-required">*</span></label>
                        <input name="nom_fournisseur" value={form.nom_fournisseur} onChange={handle} className="f-input" />
                    </div>
                    <div className="f-field">
                        <label className="f-field-label">CATÉGORIE <span className="f-required">*</span></label>
                        <select name="categorie" value={form.categorie} onChange={handle} className="f-select">
                            {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
                        </select>
                    </div>
                    <div className="f-field">
                        <label className="f-field-label">NOM DU CONTACT</label>
                        <input name="nom_contact" value={form.nom_contact} onChange={handle} className="f-input" placeholder="Nom du commercial" />
                    </div>
                    <div className="f-field">
                        <label className="f-field-label">TÉLÉPHONE</label>
                        <input name="telephone" value={form.telephone} onChange={handle} className="f-input" />
                    </div>
                    <div className="f-field">
                        <label className="f-field-label">SIREN</label>
                        <input name="siren" value={form.siren} onChange={handle} className="f-input" placeholder="Ex : BP-1234" />
                    </div>
                    <div className="f-field">
                        <label className="f-field-label">STATUT</label>
                        <select name="statut" value={form.statut} onChange={handle} className="f-select">
                            <option value={1}>Actif</option>
                            <option value={0}>Inactif</option>
                        </select>
                    </div>
                </div>
                <div className="f-modal-footer">
                    <button className="f-btn-primary" onClick={handleSubmit} disabled={loading} type="button">
                        {loading ? 'Enregistrement…' : 'Enregistrer'}
                    </button>
                    <button className="f-btn-secondary" onClick={onClose} type="button">Annuler</button>
                </div>
            </div>
        </>
    );
};

ModalEdit.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    initial: PropTypes.object,
    loading: PropTypes.bool,
};

// ─────────────────────────────────────────
// Page principale
// ─────────────────────────────────────────
const Fournisseurs = () => {
    const ideresto = JSON.parse(localStorage.getItem('user'))?.restoId;
    const token = JSON.parse(localStorage.getItem('user'))?.access_token;

    const [liste, setListe] = useState([]);
    const [chargement, setChargement] = useState(true);
    const [saving, setSaving] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [recherche, setRecherche] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);   // fournisseur à modifier

    // ── Fetch ────────────────────────────
    const fetchFournisseurs = async () => {
        setChargement(true);
        try {
            const res = await axios.get(
                `${base_api_url}depense/fournisseur/${ideresto}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            // La liste est dans res.data.fournisseur (tableau)
            const data = Array.isArray(res.data?.fournisseur)
                ? res.data.fournisseur
                : (Array.isArray(res.data) ? res.data : []);
            setListe(data);
        } catch (err) {
            console.error('Erreur récupération fournisseurs :', err);
            Swal.fire({
                icon: 'error',
                text: err.response?.data?.message || 'Impossible de charger les fournisseurs.',
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 4000,
                customClass: { popup: 'pixel-toast' },
            });
        } finally {
            setChargement(false);
        }
    };

    useEffect(() => { fetchFournisseurs(); }, []);

    // ── Ajout ────────────────────────────
    const handleSave = async (form) => {
        setSaving(true);
        try {
            const payload = {
                categorie: form.categorie,
                id_restaurant: ideresto,
                nom_contact: form.nom_contact || '',
                nom_fournisseur: form.nom_fournisseur,
                siren: form.siren || '',
                telephone: form.telephone || '',
            };

            const res = await axios.post(
                `${base_api_url}depense/fournisseur`,
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            Swal.fire({
                icon: 'success',
                text: res.data?.message || 'Fournisseur ajouté avec succès.',
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                customClass: { popup: 'pixel-toast' },
            });

            setShowModal(false);
            fetchFournisseurs();
        } catch (err) {
            console.error('Erreur ajout fournisseur :', err);
            Swal.fire({
                icon: 'error',
                text: err.response?.data?.message || 'Impossible d\'ajouter le fournisseur.',
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 4000,
                customClass: { popup: 'pixel-toast' },
            });
        } finally {
            setSaving(false);
        }
    };

    // ── Suppression ──────────────────────
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Supprimer ce fournisseur ?',
            text: 'Cette action est irréversible.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#e5e7eb',
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler',
        });
        if (!result.isConfirmed) return;

        try {
            await axios.delete(
                `${base_api_url}depense/fournisseur/${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setListe((prev) => prev.filter((f) => f.id_fournisseur !== id));
            Swal.fire({ icon: 'success', text: 'Fournisseur supprimé.', toast: true, position: 'bottom-end', showConfirmButton: false, timer: 2500, customClass: { popup: 'pixel-toast' } });
        } catch (err) {
            console.error('Erreur suppression :', err);
            Swal.fire({ icon: 'error', text: 'Impossible de supprimer ce fournisseur.', toast: true, position: 'bottom-end', showConfirmButton: false, timer: 3500, customClass: { popup: 'pixel-toast' } });
        }
    };

    // ── Mise à jour ───────────────────────
    const handleUpdate = async (form) => {
        setUpdating(true);
        try {
            const payload = {
                categorie: form.categorie,
                nom_contact: form.nom_contact || '',
                nom_fournisseur: form.nom_fournisseur,
                siren: form.siren || '',
                statut: form.statut,
                telephone: form.telephone || '',
            };
            const res = await axios.put(
                `${base_api_url}depense/fournisseur/${editItem.id_fournisseur}/${ideresto}`,
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            Swal.fire({
                icon: 'success',
                text: res.data?.message || 'Fournisseur mis à jour.',
                toast: true, position: 'bottom-end', showConfirmButton: false, timer: 3000,
                customClass: { popup: 'pixel-toast' },
            });
            setEditItem(null);
            fetchFournisseurs();
        } catch (err) {
            console.error('Erreur mise à jour fournisseur :', err);
            Swal.fire({
                icon: 'error',
                text: err.response?.data?.message || 'Impossible de mettre à jour le fournisseur.',
                toast: true, position: 'bottom-end', showConfirmButton: false, timer: 4000,
                customClass: { popup: 'pixel-toast' },
            });
        } finally {
            setUpdating(false);
        }
    };

    // ── Filtrage ─────────────────────────
    const filtres = liste.filter(
        (f) =>
            (f.nom_fournisseur || '').toLowerCase().includes(recherche.toLowerCase()) ||
            (f.nom_contact || '').toLowerCase().includes(recherche.toLowerCase()) ||
            (f.categorie || '').toLowerCase().includes(recherche.toLowerCase())
    );

    const actifs = liste.filter((f) => f.statut === 1).length;

    return (
        <div className="page-wrapper">
            <div className="f-page">
                {/* ── En-tête ── */}
                <div className="f-header">
                    <div>
                        <h1 className="f-title">Fournisseurs</h1>
                        <p className="f-subtitle">Gérez vos approvisionnements et contacts</p>
                    </div>
                    <button className="f-btn-add" onClick={() => setShowModal(true)}>
                        <Plus size={16} className="d-md-none" />
                        <span className="d-none d-md-inline">Ajouter un fournisseur</span>
                    </button>
                </div>

                {/* ── Recherche ── */}
                <div className="f-search-wrap">
                    <Search size={15} className="f-search-icon" />
                    <input
                        className="f-search"
                        placeholder="Rechercher un fournisseur..."
                        value={recherche}
                        onChange={(e) => setRecherche(e.target.value)}
                    />
                </div>

                {/* ── Stats ── */}
                <div className="f-stats">
                    <div className="f-stat-card">
                        <div className="f-stat-info">
                            <span className="f-stat-label">TOTAL FOURNISSEURS</span>
                            <span className="f-stat-value">{liste.length}</span>
                        </div>
                        <div className="f-stat-icon f-stat-icon--blue"><Truck size={22} /></div>
                    </div>
                    <div className="f-stat-card">
                        <div className="f-stat-info">
                            <span className="f-stat-label">COMMANDES EN COURS</span>
                            <span className="f-stat-value">0</span>
                        </div>
                        <div className="f-stat-icon f-stat-icon--orange"><Clipboard size={22} /></div>
                    </div>
                    <div className="f-stat-card">
                        <div className="f-stat-info">
                            <span className="f-stat-label">ACTIFS</span>
                            <span className="f-stat-value">{actifs}</span>
                        </div>
                        <div className="f-stat-icon f-stat-icon--green"><CheckCircle size={22} /></div>
                    </div>
                </div>

                {/* ── Tableau ── */}
                <div className="f-table-wrap">
                    {chargement ? (
                        <div className="f-loading">Chargement…</div>
                    ) : (
                        <table className="f-table">
                            <thead>
                                <tr>
                                    <th>FOURNISSEUR</th>
                                    <th>CATÉGORIE</th>
                                    <th>CONTACT</th>
                                    <th>SIREN</th>
                                    <th className="f-th-actions">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtres.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} className="f-empty">
                                            {liste.length === 0
                                                ? 'Aucun fournisseur. Cliquez sur « Ajouter un fournisseur » pour commencer.'
                                                : 'Aucun fournisseur correspondant à la recherche.'}
                                        </td>
                                    </tr>
                                ) : filtres.map((f) => {
                                    const cat = (f.categorie || '').toUpperCase();
                                    const initiale = (f.nom_fournisseur || '?')[0].toUpperCase();
                                    return (
                                        <tr key={f.id_fournisseur} className="f-row">
                                            <td>
                                                <div className="f-nom-cell">
                                                    <span className="f-avatar">{initiale}</span>
                                                    <span className="f-nom-wrap">
                                                        {f.statut !== 1 && (
                                                            <span className="f-badge-inactif">Inactif</span>
                                                        )}
                                                        <span className="f-nom">{f.nom_fournisseur}</span>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <span className={`f-categorie-badge ${CATEGORIE_COLORS[cat] || 'cat-autre'}`}>
                                                    {f.categorie}
                                                </span>
                                            </td>
                                            <td className="f-contact">{f.nom_contact || '—'}</td>
                                            <td className="f-contact">{f.siren || '—'}</td>
                                            <td className="f-actions-cell">
                                                <div className="f-row-actions">
                                                    <button
                                                        className="f-action-btn f-edit"
                                                        onClick={() => setEditItem(f)}
                                                        title="Modifier"
                                                    >
                                                        <Edit2 size={14} />
                                                    </button>
                                                    <button
                                                        className="f-action-btn f-delete"
                                                        onClick={() => handleDelete(f.id_fournisseur)}
                                                        title="Supprimer"
                                                    >
                                                        <Trash2 size={14} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>

                {/* ── Modal Ajout ── */}
                {showModal && (
                    <ModalAjout
                        onClose={() => setShowModal(false)}
                        onSave={handleSave}
                        loading={saving}
                    />
                )}

                {/* ── Modal Modification ── */}
                {editItem && (
                    <ModalEdit
                        onClose={() => setEditItem(null)}
                        onSave={handleUpdate}
                        initial={editItem}
                        loading={updating}
                    />
                )}
            </div>
        </div >
    );
};

export default Fournisseurs;
